import footerApi from 'Core/api/footerApi';
import {
  changeFooterContent,
  FooterContentActionType,
  getFooterContentByParams,
} from 'Core/ducks/footer';
import {AsyncResult, fromResult, Loading, ServerError} from 'Core/models/Async';
import {FooterContentDto} from 'Core/models/Footer';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import {all, call, put, takeLatest} from 'redux-saga/effects';

function* getFooterContentFromApi(action: ReturnType<typeof getFooterContentByParams>) {
  try {
    const {params} = {...action.payload};
    yield put(changeFooterContent(new Loading()));

    const result: AsyncResult<FooterContentDto> = yield call(footerApi.getPortalStaticContent, params);
    yield pipe(
      result,
      E.map(fromResult),
      E.fold(
        value => put(changeFooterContent(value)),
        value => put(changeFooterContent(value))
      )
    );
  } catch (e) {
    yield put(changeFooterContent(new ServerError()));
  }
}

export function* fetchFooterContentSaga() {
  yield takeLatest(FooterContentActionType.GET_PORTAL_STATIC_CONTENT_BY_PARAMS, getFooterContentFromApi);
}

export default function*() {
  yield all([fetchFooterContentSaga()]);
}
